import { motion } from 'framer-motion';
import type { CardDeck } from '@shared/schema';
import { CompactDeckCard } from './compact-deck-card';

interface MarketplaceGridProps {
  readonly decks: readonly (CardDeck & { canAccess?: boolean })[];
  readonly viewMode: 'grid' | 'list';
  readonly onSelect: (deckId: number) => void;
  readonly ownedDeckIds?: Set<number>;
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100, damping: 12 },
  },
};

export function MarketplaceGrid({ 
  decks, 
  viewMode, 
  onSelect,
  ownedDeckIds
}: Readonly<MarketplaceGridProps>) {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className={`grid gap-3 ${
        viewMode === "grid"
          ? "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
          : "grid-cols-1"
      }`}
    >
      {decks.map((deck) => (
        <motion.div key={deck.id} variants={itemVariants}>
          <CompactDeckCard
            deck={deck}
            onClick={() => onSelect(deck.id)}
            isOwned={ownedDeckIds?.has(deck.id)}
            canAccess={deck.canAccess !== undefined ? deck.canAccess : true}
          />
        </motion.div>
      ))}
    </motion.div>
  );
}